import toast from 'react-hot-toast';
import { useQuery } from '@tanstack/react-query';

import { ExchangeCurrencyModel, ExchangeCurrencyModelArray } from './exchange-currency.model';
import { paymentService } from '@project/services';

const toastDuration = { duration: 3000 };

type ExchangeCurrency = {
  amount: number;
  amount_currency: string;
  requested_currency: string;
};

type ExchangeCurrencyQueryParams = {
  enabled?: boolean;
  tip: ExchangeCurrency;
  sponsor_magazine: ExchangeCurrency;
};

export const useGetExchangeCurrencyQuery = (
  amount: number,
  amountCurrency: string,
  requestedCurrency: string,
  enabled = true,
) =>
  useQuery(
    ['getExchangeCurrency', amount, amountCurrency, requestedCurrency],
    () => paymentService.exchangeCurrency(amount, amountCurrency, requestedCurrency),
    {
      select: ExchangeCurrencyModel,
      enabled: enabled,
      onError: () => toast.error('Could not get converted amount', toastDuration),
      cacheTime: 0,
    },
  );

export const useGetMultipleExchangeCurrencyQuery = ({
  enabled,
  tip,
  sponsor_magazine,
}: ExchangeCurrencyQueryParams) =>
  useQuery(
    ['getMultipleExchangeCurrency', tip, sponsor_magazine],
    () => paymentService.multipleExchangeCurrency({ tip, sponsor_magazine }),
    {
      select: ExchangeCurrencyModelArray,
      enabled: enabled,
      onError: () => toast.error('Could not get converted amount', toastDuration),
      cacheTime: 0,
    },
  );
